/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PortalDocumentStatus = {
    Uploading: 'uploading',
    Processing: 'processing',
    Received: 'received',
    Accepted: 'accepted',
    NeedsAnotherLook: 'needs_another_look',
    Failed: 'failed',
} as const;
export type PortalDocumentStatus = typeof PortalDocumentStatus[keyof typeof PortalDocumentStatus];


export function instanceOfPortalDocumentStatus(value: any): boolean {
    for (const key in PortalDocumentStatus) {
        if (Object.prototype.hasOwnProperty.call(PortalDocumentStatus, key)) {
            if (PortalDocumentStatus[key as keyof typeof PortalDocumentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortalDocumentStatusFromJSON(json: any): PortalDocumentStatus {
    return PortalDocumentStatusFromJSONTyped(json, false);
}

export function PortalDocumentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalDocumentStatus {
    return json as PortalDocumentStatus;
}

export function PortalDocumentStatusToJSON(value?: PortalDocumentStatus | null): any {
    return value as any;
}

export function PortalDocumentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PortalDocumentStatus {
    return value as PortalDocumentStatus;
}

